import React, {useState, useEffect} from 'react';
import Loading from '../../components/Loading/Loading';
import {Link} from '../LoginRegister/LoginRegister.style';
import {
  ModalInvoiceWrapper,
  LoadingWrapper,
  InvoiceError,
} from './PopupModal.style';
export const PDFLink = ({
  name,
  accessToken,
  date,
  index,
  url,
  downloadPdf,
  downloadPDFIndex,
  downloadErrorIndex,
}) => {
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    if (isLoadingPdf && downloadPDFIndex === index && downloadPDFIndex > -1) {
      setIsLoadingPdf(false);
    }
  }, [isLoadingPdf, downloadPDFIndex]);

  useEffect(() => {
    if (!isError && downloadErrorIndex === index) {
      setIsError(true);
    }
  }, [isError, downloadErrorIndex]);

  const onClickHandler = () => {
    setIsLoadingPdf(true);
    setIsError(false);
    downloadPdf(url, accessToken, index);
  };
  const renderLoading = isLoadingPdf && (
    <LoadingWrapper>
      <Loading isLight={false} />
    </LoadingWrapper>
  );
  return (
    <>
      <ModalInvoiceWrapper>
        <Link onClick={onClickHandler}>
          View Invoice {index + 1} ({name})
        </Link>{' '}
        {date}
        {renderLoading}
      </ModalInvoiceWrapper>
      {isError && (
        <InvoiceError>
          Failed to download the invoice, Please try again.
        </InvoiceError>
      )}
    </>
  );
};
